import { Fragment } from 'react';

import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { Dialog } from '@/components/ui/dialog';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { fmtKeyToSymbol } from '@/lib/key';

import { FEED_KEY_GUIDE } from './feedShortcuts';

// The list of the Feed's and Home's keys, which ? opens
export const FeedShortcutsDialog: ModalFC<BaseModalFCProps> = ({
  open,
  onOpenChange,
}) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Content className="max-w-sm">
      <Dialog.Header>
        <Dialog.Title>Keyboard shortcuts</Dialog.Title>
        <Dialog.Description className="text-sm text-foreground-muted">
          On the Feed and Home, while you are not typing in a field
        </Dialog.Description>
      </Dialog.Header>
      <YStack className="gap-2.5">
        {FEED_KEY_GUIDE.map(({ label, keys }) => (
          <XStack
            key={label}
            className="items-center justify-between gap-4 text-sm"
          >
            <span className="text-foreground">{label}</span>
            <XStack className="shrink-0 items-center gap-1.5">
              {keys.map((alternative, index) => (
                <Fragment key={alternative.join('+')}>
                  {index > 0 ? (
                    <span className="text-xs text-foreground-muted">or</span>
                  ) : null}
                  {alternative.map((key) => (
                    <kbd
                      key={key}
                      className="flex h-6 min-w-6 items-center justify-center rounded-[5px] bg-secondary px-1.5 font-sans text-xs text-foreground-subtle"
                    >
                      {key === '?' ? key : fmtKeyToSymbol(key)}
                    </kbd>
                  ))}
                </Fragment>
              ))}
            </XStack>
          </XStack>
        ))}
      </YStack>
    </Dialog.Content>
  </Dialog.Root>
);
